import React from 'react'
import { v4 as uuid } from 'uuid';

function TableauRow({items, colonnes, setModalActive, setModalContext, allowEdit}) {

    const editHandler = () => {
        setModalContext(items)
        setModalActive(true)
    }

  return (
     <tr key={uuid()} className="text-lg  text-gray-800 odd:bg-orange-400 even:bg-orange-200  border-b dark:border-gray-700 border-gray-200">
        {
        colonnes.map((col) => ( !col.visible ||
            <td key={uuid()} className="px-6 py-4">
                {col.type==='checkbox'? items[col.name]===true?'oui':'non':items[col.name]}
            </td>
        ))
        }
        {
        allowEdit===true||(
            <td key={uuid()} className="px-6 py-4">
                <button className=" text-lg font-bold text-cyan-700 hover:underline"
                onClick={editHandler}>Edit</button>
            </td>
        )
        }
        </tr>
)
}

export default TableauRow